module.exports = __webpack_public_path__ + "static/media/dreamerhug-4.76dc7721.jpg";